import { create } from 'zustand';

const DEV_FORCE_OFFLINE_KEY = 'audit-system:dev-force-offline';

const readStoredForceOffline = (): boolean => {
  if (typeof window === 'undefined') return false;
  if (!import.meta.env.DEV) return false;
  return window.localStorage.getItem(DEV_FORCE_OFFLINE_KEY) === 'true';
};

const persistForceOffline = (next: boolean) => {
  if (typeof window === 'undefined') return;
  if (!import.meta.env.DEV) return;
  if (next) {
    window.localStorage.setItem(DEV_FORCE_OFFLINE_KEY, 'true');
  } else {
    window.localStorage.removeItem(DEV_FORCE_OFFLINE_KEY);
  }
};

type DevNetworkOverrideState = {
  forceOffline: boolean;
  setForceOffline: (next: boolean) => void;
};

export const useDevNetworkOverride = create<DevNetworkOverrideState>((set) => ({
  forceOffline: readStoredForceOffline(),
  setForceOffline: (next) => {
    persistForceOffline(next);
    set({ forceOffline: next });
  },
}));

export const getDevForceOffline = () => readStoredForceOffline();
